import { render, staticRenderFns } from "./SwitchSiteModal.vue?vue&type=template&id=84b7206a"
import script from "./SwitchSiteModal.vue?vue&type=script&lang=js"
export * from "./SwitchSiteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports